import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateReport, UpdateReportParams} from '../api';
import {QUERY__REPORTS} from '../queryKeys';

export const useUpdateReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateReportParams) => updateReport(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__REPORTS]});
    },
  });
};
